import { IEntityState } from '@core/state/entities/entity';
import { Action, combineReducers } from '@ngrx/store';
import { annotationQuestionEntityReducer } from '@core/state/entities/annotation-question/annotation-question.reducer';
import { stageEntityReducer } from '@core/state/entities/stage/stage.reducer';
import { searchEntityReducer } from '@core/state/entities/search/search.reducer';
import { studyDetailsEntityReducer } from './study-details/study-details.reducer';
import { membershipEntityReducer } from '@app/core/state/entities/membership/membership.reducer';
import { projectEntityReducer } from '@core/state/entities/project/project.reducer';
import { projectDetailsEntityReducer } from '@core/state/entities/project-details/project-details.reducer';
import { studyEntityReducer } from '@core/state/entities/study/study.reducer';
import { annotationEntityReducer } from '@core/state/entities/annotation/annotation.reducer';
import { screeningEntityReducer } from '@core/state/entities/screening/screening.reducer';
import { sessionEntityReducer } from '@core/state/entities/session/session.reducer';
import { outcomeDataEntityReducer } from './outcome-data/outcome-data.reducer';
import { investigatorEntityReducer } from './investigator/investigator.reducer';
import { projectGroupEntityReducer } from './project-group/project-group.reducer';
import { stageUsageReducer } from '@core/state/entities/stage-usage/stage-usage.reducer';
import { projectUsageReducer } from '@core/state/entities/project-usage/project-usage.reducer';
import { searchImportJobReducer } from '@core/state/entities/search-import-job/search-import-job.reducer';
import { joinRequestEntityReducer } from '@core/state/entities/join-request/join-request.reducer';
import { invitationEntityReducer } from '@core/state/entities/invitation/invitation.reducer';
import { invitationSecureDetailsReducer } from '@core/state/entities/invitation-secure-details/invitation-secure-details.reducer';
import { projectSecureDetailsEntityReducer } from '@core/state/entities/project-secure-details/project-secure-details.reducer';
import { investigatorSecureDetailsReducer } from '@core/state/entities/investigator-secure-details/investigator-secure-details.reducer';
import { stageAnnotationStatsEntityReducer } from '@core/state/entities/stage-annotation-stats/stage-annotation-stats.reducer';
import { projectScreeningStatsReducer } from '@core/state/entities/project-screening-stats/project-screening-stats.reducer';
import { membershipScreeningStatsEntityReducer } from '@core/state/entities/membership-screening-stats/membership-screening-stats.reducer';
import { membershipAnnotationStatsEntityReducer } from '@core/state/entities/membership-annotation-stats/membership-annotation-stats.reducer';
import { IEntityKeyTypeMap } from '@core/state/entities/entities';
import { adminInvestigatorReducer } from '@core/state/entities/admin-investigators/admin-investigator.reducer';
import { emailTemplateReducer } from '@core/state/entities/email-templates/email-template.reducer';
import { projectPermissionSetEntityReducer } from './project-permission-set/project-permission-set.reducer';
import { stagePermissionSetEntityReducer } from './stage-permission-set/stage-permission-set.reducer';
import { reviewerScreeningStatsEntityReducer } from '@core/state/entities/reviewer-screening-stats/reviewer-screening-stats.reducer';
import { reviewerAnnotationStatsEntityReducer } from '@core/state/entities/reviewer-annotation-stats/reviewer-annotation-stats.reducer';
import { bulkPdfUploadJobReducer } from '@core/state/entities/bulk-pdf-upload-job/bulk-pdf-upload-job.reducer';
import { riskOfBiasJobReducer } from '@core/state/entities/risk-of-bias-job/risk-of-bias-job.reducer';
import { bulkStudyUpdateJobReducer } from '@core/state/entities/bulk-study-update-job/bulk-study-update-job.reducer';
import { dataExportJobReducer } from '@core/state/entities/data-export-job/data-export-job.reducer';
import { dataExportRequestReducer } from '@core/state/entities/data-export-request/data-export-request.reducer';

export type IEntitiesState = {
  [key in keyof IEntityKeyTypeMap]: IEntityState<IEntityKeyTypeMap[key]>;
};

type ReducerFunctionMap = {
  [key in keyof IEntityKeyTypeMap]: (
    state: IEntityState<IEntityKeyTypeMap[key]>,
    action: Action
  ) => IEntityState<IEntityKeyTypeMap[key]>;
};

const reducerFunctionMap: ReducerFunctionMap = {
  screenings: screeningEntityReducer,
  memberships: membershipEntityReducer,
  projects: projectEntityReducer,
  projectDetails: projectDetailsEntityReducer,
  projectSecureDetails: projectSecureDetailsEntityReducer,
  searches: searchEntityReducer,
  stages: stageEntityReducer,
  projectScreeningStats: projectScreeningStatsReducer,
  stageAnnotationStats: stageAnnotationStatsEntityReducer,
  membershipScreeningStats: membershipScreeningStatsEntityReducer,
  membershipAnnotationStats: membershipAnnotationStatsEntityReducer,
  annotationQuestions: annotationQuestionEntityReducer,
  studies: studyEntityReducer,
  studyDetails: studyDetailsEntityReducer,
  annotations: annotationEntityReducer,
  outcomeData: outcomeDataEntityReducer,
  sessions: sessionEntityReducer,
  investigators: investigatorEntityReducer,
  investigatorSecureDetails: investigatorSecureDetailsReducer,
  projectGroups: projectGroupEntityReducer,
  stageUsages: stageUsageReducer,
  projectUsages: projectUsageReducer,
  searchImportJobs: searchImportJobReducer,
  riskOfBiasJobs: riskOfBiasJobReducer,
  bulkPdfUploadJobs: bulkPdfUploadJobReducer,
  joinRequests: joinRequestEntityReducer,
  invitations: invitationEntityReducer,
  invitationSecureDetails: invitationSecureDetailsReducer,
  adminInvestigators: adminInvestigatorReducer,
  emailTemplates: emailTemplateReducer,
  projectPermissionSets: projectPermissionSetEntityReducer,
  stagePermissionSets: stagePermissionSetEntityReducer,
  reviewerScreeningStats: reviewerScreeningStatsEntityReducer,
  reviewerAnnotationStats: reviewerAnnotationStatsEntityReducer,
  bulkStudyUpdateJobs: bulkStudyUpdateJobReducer,
  dataExportJobs: dataExportJobReducer,
  dataExportRequests: dataExportRequestReducer,
};

export const entitiesReducer = combineReducers(reducerFunctionMap);
